import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import type { TypographyProps } from "@mui/material";
import type Competence from "constants/Competence";
import competenceMap from "constants/CompetenceMap";

interface CompetenceChipProps extends TypographyProps {
  competence: Competence | string;
}

function CompetenceChip({
  competence,
  variant = "body2",
  sx,
  ...typographyProps
}: Readonly<CompetenceChipProps>): ReactNode {
  const competenceAssociation = competenceMap.get(competence.toUpperCase() as Competence);

  if (competenceAssociation == null) {
    return null;
  }

  return (
    <Typography
      variant={variant}
      {...typographyProps}
      color={`${competenceAssociation.color}.dark`}
      sx={{
        width: "40px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: `${competenceAssociation.color}.main`,
        paddingY: 0.4,
        backgroundColor: `${competenceAssociation.color}.light`,
        fontWeight: 600,
        borderRadius: 1,
        display: "inline-block",
        textAlign: "center",
        ...sx,
      }}
      component="span">
      {competenceAssociation.smallLabel}
    </Typography>
  );
}

export default CompetenceChip;
